// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3vJ2h","inner":"Footer_inner__1yYdN","nextIcon":"Footer_nextIcon__meSzI","innerLeft":"Footer_innerLeft__3vpRe"};